<template>
  <div>
    <div :id="mapId" class="map-container" v-if="rerender"></div>
    <div :class="{ 'map-pin': true, drag: dragging }" v-show="panelMode === 'location-pin'"><i class="fa fa-map-pin fa-2x brand-text"></i></div>
    <div class="booking-map-cover" v-show="showCover">
      <div class="lds-ripple"><div></div><div></div></div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import _MapBehaviorUtils from './_map-behavior-utils'
import _MapUtils from './_map-utils'

export default {
  name: 'booking-map',
  props: ['mapId'],
  data () {
    return {
      map: null,
      platform: null,
      behavior: null,
      ui: null,
      adjustZoom: false,
      mapIds: {
        resRoute: 'resRoute',
        pickup: 'pickupMarker',
        pickupLabel: 'pickupLabel',
        dropoff: 'dropoffMarker',
        dropoffLabel: 'dropoffLabel',
        extraStop: 'extraStopMarker'
      },
      showCenter: false,
      dragging: false,
      nearestDriver: null,
      routeTravelTime: 0,
      testCoords: [],
      showCover: false,
      rerender: true
    }
  },
  computed: {
    mapHeight () { return 200 },
    panelMode () { return 'location-pin' }
  },
  methods: {
    init () {
      let self = this
      let mapContainer = document.getElementById(self.mapId)
      self.platform = new window.H.service.Platform({apikey: CONFIG.hereApi.key})

      let defaultLayers = self.platform.createDefaultLayers()
      self.map = new window.H.Map(mapContainer,
        defaultLayers.vector.normal.map, {
          center: {
            lat: 33.942791,
            lng: -118.410042
          },
          zoom: 11,
          pixelRatio: window.devicePixelRatio ? 2 : 1
        }
      )

      self.map.addEventListener('mapviewchangestart', evt => {
        self.map.getViewPort().resize()
      })
      self.map.addEventListener('mapviewchangeend', evt => {
        _MapUtils.resize(this.map, 0)
        if (!self.adjustZoom) {
          return
        }
        self.adjustZoom = false
        self.map.setZoom(self.map.getZoom() - 1, true)
      })
      /* eslint-disable no-unused-vars */
      self.behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.map))
      _MapBehaviorUtils.toggleTilt(self.behavior)
      _MapBehaviorUtils.toggleHeading(self.behavior)
      // behavior.disable()
      /* eslint-enable no-unused-vars */
      self.ui = window.H.ui.UI.createDefault(self.map, defaultLayers)
      const zoomControl = self.ui.getControl('zoom');
      zoomControl.setVisibility(false);
      const mapSettingsControl = self.ui.getControl('mapsettings');
      mapSettingsControl.setVisibility(false);

      self.map.addEventListener('dragstart', evt => {
        if (self.panelMode === 'location-pin') {
          self.dragging = true
        }
      })
      self.map.addEventListener('dragend', evt => {
        self.showCenter = true

        if (self.panelMode === 'location-pin') {
          let center = self.map.getCenter()
          self.$store.commit('setMapLocation', center)
          self.dragging = false
        }
      })

      // _MapUtils.adjustStyle(self.map)
    },
    centerMap (value) {
      let self = this
      self.showCenter = false

      // default centering
      self.map.getViewModel().setLookAtData({
        position: {
          lat: value.lat,
          lng: value.lng
        },
        zoom: 14
      }, true)
    }
  },
  watch: {
    panelMode (value) {
      let self = this
      self.showCover = false
      // clear map
      if (value === 'location-pin') {
        _MapUtils.removeObject(self.map, self.mapIds.pickup)
        _MapUtils.removeObject(self.map, self.mapIds.extraStop)
        _MapUtils.removeObject(self.map, self.mapIds.dropoff)
        _MapUtils.removeObject(self.map, self.mapIds.resRoute)
        _MapUtils.removeObject(self.map, self.mapIds.pickupLabel)
        _MapUtils.removeObject(self.map, self.mapIds.dropoffLabel)
      }
    },
    mapHeight (value) { _MapUtils.resize(this.map, 375) }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.map-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 550px;
  height: calc(480px - 150px);
  
  @media only screen and (max-width: 640px) {
    width: 100%;
    height: calc(100% - 150px);
  }
}

.map-pin {
  position: absolute;
  top: calc(50% - 28px);
  left: calc(50% - 10.5px);
  z-index: 3;
  text-align: center;
  width: 20px;
  height: 32px;
  transition: all 250ms;

  &:after {
    content: '';
    background-color: rgba(0,0,0,0.3);
    width: 10px;
    height: 7px;
    position: absolute;
    top: 28px;
    left: 5px;
    border-radius: 100px;
    z-index: 2;
    box-shadow: 0 0 8px rgba(0,0,0,0.5);
    opacity: 1;
    transition: all 250ms;
  }

  &.drag {
    top: calc(50% - 40px);
    &:after { opacity: 1; top: 40px; background-color: rgba(0,0,0,0.4); box-shadow: 0 0 6px rgba(0,0,0,0.7); }
  }
}

.center-button {
  position: absolute;
  bottom: 160px;
  right: 15px;
  z-index: 1;
  padding: 7px;
  background-color: #fff;
  border-radius: 50px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.5);
  font-size: 16px;
  line-height: 16px;
  overflow: hidden;
  width: 30px;
  height: 30px;
  display: block;
  text-align: center;
  opacity: 1;
  transition: all 250ms;

  &.hide {
    opacity: 0;
    height: 0;
    width: 0;
    padding: 0;
  }
}

.booking-map-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.1);
  transition: all 250ms;

  &.hide {  }

  & .lds-ripple {
    display: inline-block;
    position: absolute;
    top: calc(50% - 32px);
    left: calc(50% - 32px);
    width: 64px;
    height: 64px;
  }
  & .lds-ripple div {
    position: absolute;
    border: 4px solid #000;
    opacity: 0;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  & .lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
  }
  @keyframes lds-ripple {
    0% {
      top: 28px;
      left: 28px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: -1px;
      left: -1px;
      width: 58px;
      height: 58px;
      opacity: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// BookingMap.vue?65600eca